import PropTypes from 'prop-types';

/**
 * Business idea definition
 */
export const BusinessEntityAdvisor = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  // category: PropTypes.string,
  report: PropTypes.oneOfType([
    // Future backend structure with sections array
    PropTypes.shape({
      sections: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired,
          content: PropTypes.string.isRequired
        })
      )
    }),
    // Current flat structure (flexible - can have any report fields)
    PropTypes.object
  ]),
  businessPlan: PropTypes.object
});

/**
 * User profile from ChoiceFlow answers
 */
export const UserProfile = PropTypes.shape({
  preferences: PropTypes.object,
  answers: PropTypes.object.isRequired
});

/**
 * Business results data structure
 * Supports either 'ideas' or 'items' array (one is required)
 * @param {object} props - Component props
 * @param {string} propName - Property name
 * @param {string} componentName - Component name
 * @returns {Error|null} Error if validation fails, null otherwise
 */
export const BusinessEntityAdvisorV2ResultsData = (props, propName, componentName) => {
  // eslint-disable-next-line react/destructuring-assignment -- Dynamic property access required for PropType validator
  const data = props[propName];

  if (!data) {
    return new Error(`The prop '${propName}' is required in '${componentName}'.`);
  }

  const hasSections =
    data.sections &&
    typeof data.sections === 'object' &&
    !Array.isArray(data.sections) &&
    Object.keys(data.sections).length > 0;
  if (!hasSections) {
    return new Error(
      `The prop '${propName}' in '${componentName}' must have a 'sections' key with at least one section.`
    );
  }

  return null;
};

/**
 * Main BusinessResults props
 */
export const BusinessEntityAdvisorV2ResultsProps = PropTypes.shape({
  data: BusinessEntityAdvisorV2ResultsData,
  onEmailReport: PropTypes.func,
  onGenerateMore: PropTypes.func,
  onIdeaSelect: PropTypes.func
});
